import { useSelector } from "../redux/store";
import { AppState } from "../Common/Reducer/rootReducerTypes";

export function useDisplayName() {
  const userIdentity = useSelector((state: AppState) => state.user);
  const userInfoState = useSelector((state: AppState) => state.userInfo);

  const firstName = userIdentity?.profile['first-name'];
  const lastName = userIdentity?.profile['last-name'];

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return userInfoState.userInformation.name ?? "";
}
